import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Card from '../ui/Card';
import LazyImage from '../ui/LazyImage';
import DietaryBadge from '../ui/DietaryBadge';
import Button from '../ui/Button';
import { useLanguage } from '../../context/LanguageContext';
import { getFeaturedItems } from '../../data/menu';

export default function FeaturedDishes() {
  const { t, language } = useLanguage();
  const featuredItems = getFeaturedItems().slice(0, 3);

  return (
    <section className="py-16 md:py-24 bg-cream-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            {t('featured.title')}
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            {t('featured.subtitle')}
          </p>
        </div>

        {/* Featured Items Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-12">
          {featuredItems.map((item) => (
            <Card key={item.id} hover padding="none" className="overflow-hidden">
              <div className="relative">
                <LazyImage
                  src={item.image}
                  alt={item.name[language]}
                  aspectRatio="4/3"
                  className="w-full"
                />
                {/* Dietary badges */}
                {item.dietary.length > 0 && (
                  <div className="absolute top-3 left-3 flex gap-1">
                    {item.dietary.map((diet) => (
                      <DietaryBadge key={diet} type={diet} />
                    ))}
                  </div>
                )}
              </div>
              <div className="p-5">
                <h3 className="font-display text-xl font-semibold text-gray-900 dark:text-white mb-2">
                  {item.name[language]}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm mb-4 line-clamp-2">
                  {item.description[language]}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-primary-700 dark:text-primary-400">
                    {item.price.toFixed(2).replace('.', ',')} €
                  </span>
                  <Link
                    to={`/menu#${item.category}`}
                    className="text-accent-600 hover:text-accent-700 dark:text-accent-400 dark:hover:text-accent-300 font-medium text-sm flex items-center gap-1"
                  >
                    {t('common.readMore')}
                    <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <Button to="/menu" variant="outline" size="lg">
            {t('featured.viewAll')}
            <ArrowRight className="w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
}
